import React from "react";
import "./Header.css";
import Typed from "react-typed";
import GetAppIcon from "@material-ui/icons/GetApp";

const Header = () => {
  return (
    <div className="header">
      <div className="container pt-5 pb-3 mt-5 header-container">
        <p className="font hi">👋 Hi,my name is</p>
        <p className="font-heading my-name">
          <span className="first-name">Mariam</span> Chowdhury
        </p>
        <Typed
          className="typed-text font typed-font my-3"
          strings={[
            "I am a Front End Developer",
            "I am a Programmer",
            "I am a Student",
          ]}
          typeSpeed={50}
          backSpeed={60}
          loop
        />
        <a
          href="https://drive.google.com/file/d/1BZBDwQRwDCeqTawKWrUAczYC7-ETOOiE/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button class="custom-btn btn-15 font mt-5">
            <span>
              <GetAppIcon />
              Resume
            </span>
          </button>
        </a>
      </div>
    </div>
  );
};

export default Header;
